export const unifyEvent = (e) => ({
    eventId: e.id,
    gameScore: e.score,
    liveGameState: e.liveGameState,
    isLive: e.isLive
});
//# sourceMappingURL=unifyEvent.js.map